// extracted by mini-css-extract-plugin
export default {"code":"styles_code__MucUq"};